/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Progress } from '@ant-design/plots';
import H3Text from '@Uilib/h3Text';
import './style.scss';
import { Spin } from 'antd';

/**
 *
 */
function MetricWithStatusSplit({
  data, loading, showOrderValue, MONEY,
}) {
  return (
    <div className="metric-with-status-split__wrapper">
      {loading && (
        <div className="widget-loader">
          <Spin />
        </div>
      )}
      <div className="metric-with-status-split">
        <div className="metric-with-heading-split">
          <H3Text text={data?.entity?.toProperCase()} className="metric-with-status-split__title" />
          <H3Text text={showOrderValue ? `${MONEY(data?.value || '0')} (${data?.count} Orders)` : `${data?.count} Orders`} className="metric-with-status-split__title" />
        </div>
        {
            data?.list?.map((item, index) => (
              <Fragment key={index}>
                {item?.url ? (
                  <Link to={item?.url} target="_blank">
                    <div className="metric-with-status-split__bar">
                      <div className="metric-with-status-split__item-header">
                        <H3Text text={item?.label?.toUpperCase()} className="metric-with-status-split__item-label" />
                        <H3Text text={showOrderValue ? `${MONEY(item?.value || '0')} (${item?.count} Orders)` : `${item?.count} Orders`} className="metric-with-status-split__item-value" />
                      </div>
                      <Progress {...{
                        height: 16,
                        width: '100%',
                        autoFit: true,
                        percent: (item?.value / data?.value),
                        color: [item?.color, '#E8EDF3'],
                        style: {
                          borderRadius: '5px',
                        },
                        tooltip: {
                          enterable: true,
                          follow: true,
                          customContent: (index, row) => (
                            <H3Text text={`${item?.count} Purchase Orders`} className="" />
                          ),
                        },
                      }}
                      />
                    </div>
                  </Link>
                )
                  : (
                    <div className="metric-with-status-split__bar">
                      <div className="metric-with-status-split__item-header">
                        <H3Text text={item?.label?.toUpperCase()} className="metric-with-status-split__item-label" />
                        <H3Text text={`${MONEY(item?.value || '0')} (${item?.count} Orders)`} className="metric-with-status-split__item-value" />
                      </div>
                      <Progress {...{
                        height: 16,
                        width: '100%',
                        autoFit: true,
                        percent: (item?.value / data?.value),
                        color: [item?.color, '#E8EDF3'],
                        style: {
                          borderRadius: '5px',
                        },
                        tooltip: {
                          enterable: true,
                          follow: true,
                          customContent: (index, row) => (
                            <H3Text text={`${item?.count} Purchase Orders`} className="" />
                          ),
                        },
                      }}
                      />
                    </div>
                  )}
              </Fragment>
            ))
        }
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
});

MetricWithStatusSplit.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
  loading: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MetricWithStatusSplit));
